import { CampaignComponent } from '@forwardflow/components/Campaign'
import { DashboardContainer } from '@forwardflow/components/Dashboard'

const Campaign = () => {
   return (
      <>
         <style>{`html { overflow: hidden; }`}</style>
         <DashboardContainer>
            <CampaignComponent />
         </DashboardContainer>
      </>
   )
}

export default Campaign
